module.exports = "https://static.moomoo.com/components/multi-media-financial-report/images/avatar.a7c8065b09.png";